<template>
  <div
      class="px-3 pb-3 d-flex"
      :class="'justify-'+messageAlign"
  >
    <v-sheet
        v-if="message.type==='event'"
        class="body-2 pa-2 muted1 text-center caption grey lighten-4"
        max-width="400"
        rounded
    >
      {{message.text}} в {{$tools.dateFormat(message.created)}}
    </v-sheet>
    <v-sheet
        v-else
        class="d-inline-block text-left overflow-hidden" style="border:solid 1px #DDD !important;max-width:50%"
        rounded
        :color="messageUser===$store.state.user?.id ? 'light-green lighten-5' : 'white'"
    >
      <div class="px-2 py-1" :class="messageClass">
        <div v-if="messageUser===null" class="caption">
          {{message.dialogUser.name}}
        </div>
        <a v-else class="caption" :href="'/panel/user/'+messageUser?.type+'/'+messageUser?.id+'/'" target="_blank">
          {{$tools.userFullName(messageUser)}}
        </a>
        <div v-if="message.text!==null" v-html="$tools.nl2br(message.text)" class="body-2 mt-1 mb-2"></div>
        <div v-for="attach in message.dialogMessageAttachs" :key="attach.id" class="body-2 mt-1 mb-2">
          <v-sheet
              v-if="$tools.getFileTypeByPath(attach.url).includes('image')"
              @click="$tools.openUrl(attach.url, true)"
              width="250" height="250" class="clickable overflow-hidden" rounded color="black"
          >
            <img :src="attach.url" alt="" class="full-width fill-height" style="object-fit:contain;"/>
          </v-sheet>
          <v-sheet
              v-else-if="$tools.getFileTypeByPath(attach.url).includes('audio')"
              width="500" color="transparent"
          >
            <audio :src="attach.url" controls class="mt-2">
              Прослушивание не поддерживается вашим браузером.
              <a :href="attach.url" target="_blank">Скачать</a>.
            </audio>
          </v-sheet>
          <v-sheet
              v-else-if="$tools.getFileTypeByPath(attach.url).includes('video')"
              width="250" height="250" class="clickable overflow-hidden" rounded color="black"
          >
            <video :src="attach.url" controls class="full-width fill-height"></video>
          </v-sheet>
          <div v-else-if="$tools.getFileTypeByPath(attach.url).includes('unknown')">
            <v-btn small depressed @click="$tools.openUrl(attach.url, true)">
              <v-icon small class="mr-2">mdi-file</v-icon>Файл "{{attach.url.split('.').pop().toLowerCase()}}"
            </v-btn>
          </div>
        </div>
        <v-row no-gutters class="caption font-weight-regular">
          <v-col>
            <div v-if="message.reaction!==null" class="d-inline-block">
              {{message.reaction}}
            </div>
          </v-col>
          <v-col cols="auto" class="text-no-wrap">
            {{$tools.dateFormat(message.created)}}
          </v-col>
        </v-row>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data: () => ({
    messageClass:'',
  }),
  computed:{
    messageAlign(){
      let align = 'start';
      if(this.messageUser===this.$store.state.user?.id || !this.messageUserClient)
        align = 'end';
      if(this.message.type==='event')
        align = 'center';
      return align;
    },
    messageUser(){
      return this.message.dialogUser?.user
    },
    messageUserClient(){
      return this.message.dialogUser?.provider!=='internal';
    },
    provider(){
      return this.message.dialogUser.provider
          // добавляем пробел перед заглавными буквами, кроме первой
          .replace(/([A-ZА-ЯЁ])/g, ' $1')
          .trim()
          // первую букву делаем заглавной
          .replace(/^./, char => char.toUpperCase())
    },
  },
  mounted() {
    if(this.message.new){
      this.messageClass = 'blinkWarning';
      setTimeout(()=>{
        this.messageClass = '';
        this.message.new = false;
      }, 2000)
    }
  },
}
</script>